import { eGENA_Checkliste } from '../../visionet/Checkliste';
import { config } from '../../../package.json';
import { Optional } from '@angular/core';
import { GlobalConstants } from './GlobalConstants';

//import jsonTranslations from '../../assets/translation.json';
const gettextJs = require('gettext.js');


export const kenntnisnahmeKey = "Haftungsausschluss-Kenntnisnahme";
export const applicationLifetimeStorageName = "'_eGENA_lifetime";
export const kenntnisnahmeSpeicherwert = "Haftungsausschluss zur Kenntnis genommen";


/**	Das ist das Datenobjekt für das globale Singleton "GlobalsSingleton"
 *	Und das sollte auch nur ein einziges Mal initialisiert werden.
 *	Aaaaaaaaber: IONIX/Angular (wer weiß schon wer) geht in seiner 
 *	Startphase alle Klassen durch und erzeugt dabei implizit auch ein Objekt dieser Klasse.
 *	Und das geschieht noch VOR der expliziten Instanziierung in "GlobalsSingleton".
 *	Um nun zu unterscheiden, ob es sich um eine implizite oder explizite Initialisierung handelt,
 *	hat der Konstruktor einen optionalen Parameter.
 *
 *	Warum der Aufwand? Warum nicht einfach zwei Instanzen, ist ja egal....
 *
 *	Weil bei der ersten, impliziten, Initialisierung gleich die Übersetzung initialisiert wird.
 *	Und beim Initialisiern der Übersetzhung "frisst" die gettext-Bibliothek
 *	das leere JSON-Element, das die ganzen Meta-Informationen enthält, einfach weg!
 *	Bei der zweiten, expliiziten Initialisierung fehlt das dann und es kommt zu einer Exception.
 */
export class GlobalValues {

 	applicationMode: string;

	constructor(@Optional() initializeMe? : boolean) {

		if (initializeMe == undefined || !initializeMe) {
			console.debug("GlobalValues.constructor(): impliziter Aufruf, wird ignoriert.");
			return;
		}

		this.loadTranslationFileInitial();


		this.width = window.outerWidth;
		this.height = window.outerHeight;
		/*	Erst mal entscheiden ob wir auf einem "kleinen" Bildschirm laufen.
		 *	Die völlig willkürliche Grenze dafür ist eine Bildschirmbreite von 700px
		 *	Dabei müssenw wir aber aufpassen: ein PC-Monitor is üblicherweis im Landscape-Modus,
		 *	also breiter als hoch. Das ist trotzdem OK.
		 *	Wie aber detektieren wir also ob wir auf einem PC im Breitbildformat oder auf einem Telefon im Breitbildformat sind?
		 *	Wir nehmen den kleineren von beiden Werten aus Bildschirmbreite und Höhe.
		 *	Dabei gehen wir davon aus, dass niemand mehr auzf einem PC-Bildschirm arbeitet,
		 *	der vertikal weniger als 700 Pixwel auflösung hat. Also kein 640x480 mehr.  
		 */
		let minimalwert: number = Math.min(screen.width, screen.height);
		console.debug("Minimalwert(" + screen.width + ", " + screen.height + ") = " + minimalwert);

		if (minimalwert < 700) {
			this.applicationMode = "Phone";
		}
		else {
			this.applicationMode = "TabletOrDesktop";
		}
		console.debug("applicationMode => " + this.applicationMode);

		// Ist es ein mobiles Gerät?
		console.debug("window.navigator.userAgent = " + window.navigator.userAgent);
		if (typeof navigator.maxTouchPoints !== 'undefined') {
			console.debug("navigator.maxTouchPoints = " + navigator.maxTouchPoints);
			if (navigator.maxTouchPoints === 0) {
				// Das ist garantiert KEIN mobiles, drehbares Gerät
				this._isMobileDevice = false;
				console.debug("navigator.maxTouchPoints = 0 (kein Touchscreen) => _isMobileDevice" + this._isMobileDevice);
			}
			else {
				// Auch Laptops mit Touchscreen 
				const isIEOrEdge :boolean = /windows|msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
				if (isIEOrEdge) {
					// Touchscreen UND Windows, dann kann es nicht mobil sein.
					this._isMobileDevice = false;
					console.debug("navigator.maxTouchPoints > 0 aber windows => _isMobileDevice" + this._isMobileDevice);
				}
				else {
					const isIPhoneSimulation :boolean = /iPhone/i.test(window.navigator.userAgent)
					if (isIPhoneSimulation) {
						this._isMobileDevice = true
						console.debug("navigator.maxTouchPoints > 0 aber iPhone => _isMobileDevice" + this._isMobileDevice + " (Simulation z.B. per Chrome)");
						}
					else {
						const isMacOs :boolean = /Mac OS/i.test(window.navigator.userAgent)
						if (isMacOs) {
							this._isMobileDevice = false
							console.debug("navigator.maxTouchPoints > 0 aber Mac OS => _isMobileDevice" + this._isMobileDevice);
							}
						else {
							this._isMobileDevice = true;
							console.debug("_isMobileDevice" + this._isMobileDevice);
						}
					}
				}
			}
		}
		else {
			// Wenn navigator.maxTouchPoints  nicht definiert ist, handelt es sich um einen FireFox unter Android
			this._isMobileDevice = true;
			console.debug("navigator.maxTouchPoints = undefined => _isMobileDevice" + this._isMobileDevice);
		}


		// Wenn es ein mobiles, drehbares Gerät ist, dann das Drehen per CSS verhindern
		if (this._isMobileDevice) {
			console.log("Versuche Drehen zu verhindern...");
			// Dort, wo es möglich ist, pinnen wir die Orientierung auf Portrait
			if (typeof window.screen !== 'undefined' && typeof window.screen.orientation !== 'undefined' && typeof window.screen.orientation.lock !== 'undefined' && typeof window.screen.orientation.lock === 'function') {
				document.documentElement.requestFullscreen()
				.catch((e:any) => {
//					alert("requestFullscreen() ==> Katsch: " + e);
				});
				window.screen.orientation.lock("portrait")
				.catch((e:any) => {
//					alert("Katsch: " + e);
				});
				console.debug("window.screen.orientation.lock('portrait-primary')");
//				this._debugMessage = "window.screen.orientation.lock('portrait-primary')";
			}				
			else if (typeof screen.orientation !== 'undefined' && typeof screen.orientation.lock !== 'undefined' && typeof screen.orientation.lock === 'function') {
				window.screen.orientation.lock
				screen.orientation.lock("portrait")
				.catch(() => {
//						alert("Katsch");
				});
				console.debug("screen.orientation.lock(''portrait'')");
//				this._debugMessage = "screen.orientation.lock(''portrait'')";
			}
			else {
				let pseudoScreen : any = screen;
				if (typeof pseudoScreen.lockOrientation !== 'undefined' && typeof pseudoScreen.lockOrientation === 'function') {
					pseudoScreen.lockOrientation("portrait-primary")
					.catch(() => {
//							alert("Katsch");
					});

					console.debug("screen.lockOrientation('portrait-primary')");
//					this._debugMessage = "screen.lockOrientation('portrait-primary')";
				}
				else {
//					this._debugMessage = "Weder 'screen.orientation.lock' noch 'screen.lockOrientation'";
				}
			}

			document.body.classList.add("can-rotate");
			let ionApp : HTMLElement = document.getElementById("ion-app-wrapper");
			if (ionApp !== undefined) {
				ionApp.classList.add("can-rotate");
			}
		}


		// Ist es ein Telefon, also ein kleines Geräte?
		if (this.applicationMode == "Phone") {
			document.body.classList.add("small-device-mode");
		}
		else {
			document.body.classList.add("large-device-mode");
		}

		console.debug("GlobalValues: applicationMode = " + this.applicationMode);
	}


	/*	Erst einmal nachsehen, ob eine Übersetzung speziell für Telefone existiert.
	 *	Dazu wird an den key ein "-phone" angehängt, also "Gehirn-phne" für "Gehirn"
	 *	Endet die Übersetzung mit "-phone" gab es wohl keine.
	 *	Dann nehmen wir die "normale" Übersetzung. 
	 *
	 */
	public translate(key : string, ...data: any []) : string {
		if (this.isPhone()) {
			let phoneTranslation = this.translator.gettext(key+"-phone", data);
//			console.debug("translate: phoneTranslation('" + key+"-phone', ''" + data + "')  ==> '" + phoneTranslation);
			if (!phoneTranslation.endsWith("-phone")) {
				// console.debug("'" + key +"' --> Phone-Trans '" + phoneTranslation);
				return phoneTranslation;
			}				
		}

		let translation = this.translator.gettext(key, data);
//		console.debug("translate: translation('" + key + "', ''" + data + "')  ==> '" + translation);
		// console.debug("'" + key +"' --> Trans '" + translation);
		return translation;
	}



	private translator : any;
	public getTranslator() : any {
		return this.translator;
	}


	private _debugMessage : string | undefined = undefined;
	public getDebutMessage() : string | undefined {
		return this._debugMessage;
	}


	private _isMobileDevice: boolean;
	public isMobileDevice() : boolean {
		return this._isMobileDevice;
	}



	isPhone() : boolean {
		return this.applicationMode == "Phone";
	}



	width: number;
	getWidth() : number {
		return this.width;
	}
	height:number;
	getHeight() : number {
		return this.height;
	}



	private curSearchResultChecklists : eGENA_Checkliste[];
	setCurSearchResultChecklists(value : eGENA_Checkliste[]) {
		this.curSearchResultChecklists = value;
	}
	getCurSearchResultChecklists() : eGENA_Checkliste[] {
		return this.curSearchResultChecklists;
	}



	private azIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	setAzIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.azIndex = value;
	}
	getAzIndex() : Map<string, eGENA_Checkliste[]> {
		return this.azIndex;
	}



	private abcdeIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	setAbcdeIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.abcdeIndex = value;
	}
	getAbcdeIndex() : Map<string, eGENA_Checkliste[]> {
		return this.abcdeIndex;
	}



	private bodynavIndex: Map<string, eGENA_Checkliste[]> =  new Map();
	setBodynavIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.bodynavIndex = value;
	}
	getBodynavIndex() : Map<string, eGENA_Checkliste[]> {
		return this.bodynavIndex;
	}



	private fuzzySearchIndex:eGENA_Checkliste[] = [];
	setFuzzySearchIndex(value : eGENA_Checkliste[]) {
		this.fuzzySearchIndex = value;
	}
	getFuzzySearchIndex() : eGENA_Checkliste[] {
		return this.fuzzySearchIndex;
	}

















	/**	Hier laden wir die JSON-Datei mit den Übersetzungsdaten rein.
	 *	Wir machen das per fetch() weil es sonst per Server nicht funktioniert.
	 *
	 *	Entweder sind die Daten bereits mal geladen worden, dann sind sie im wondow-Objekt unter
	 *	dem Attribut GlobalConstants.WINDOW_PROPERTY_TranslationData hinterlegt.
	 *
	 *	Andernfalls holen wir sie per fetch im getTranslationfile()
	 */
	private getTranslationData() : any {
		if (window[GlobalConstants.WINDOW_PROPERTY_TranslationData]) {
			console.debug("getTranslationData(): Daten bereits unter '" + GlobalConstants.WINDOW_PROPERTY_TranslationData + "' verfügbar.");
			return window[GlobalConstants.WINDOW_PROPERTY_TranslationData];
		}
		else {
			console.error("getTranslationData(): keine Daten unter '" + GlobalConstants.WINDOW_PROPERTY_TranslationData + "' gefunden");
			throw new Error("getTranslationData(): keine Daten unter '" + GlobalConstants.WINDOW_PROPERTY_TranslationData + "' gefunden");
		}
	}


	private loadTranslationFileInitial() {
		let translationData : any = this.getTranslationData();
		try {
			console.log("GlobalValues: lade gettextJs...");

			if (!('__esModule' in gettextJs) || !('default' in gettextJs)) {
				console.error("GlobalValues: gettextJs nicht korrekt geladen!");
				console.error("gettextJs hat folgende Attribute:");
				let keys : string[] = Object.getOwnPropertyNames(gettextJs);
				for (const key of keys) {
					console.log("\t'" + key + "'");
				}

				throw new Error("GlobalValues: gettextJs nicht korrekt geladen!");
			}

			console.log("GlobalValues: init gettextJs...");
			this.translator = gettextJs.default();
			if (!('setMessages' in this.translator)) {
				console.error("GlobalValues: gettextJs nicht korrekt initialisiert!");
				console.error("GlobalValues: gettextJs hat folgende Attribute:");
				let keys : string[] = Object.getOwnPropertyNames(this.translator);
				for (const key of keys) {
					console.log("\t'" + key + "'");
				}

				throw new Error("GlobalValues: gettextJs nicht korrekt initialisiert!");
			}


			let error = this.checkTranslationFile(translationData);
			if (error) {
				console.error("loadTranslationFileInitial(): Fehler beim Überprüfen der Übersetzungsdatei: " + error);
				console.error("Der Inhalt der Übersetzungsdatei:\n" + translationData);
				throw new Error("Fehler beim Überprüfen der Übersetzungsdatei: " + error);
			}
			else {
				this.initTranslation(translationData);
			}
		} catch (error) {
			console.error("Fehler in loadTranslationFileInitial(): " + error.message);
			throw error;
		}

	}


	private checkTranslationFile(jsonTranslations : any) : string {
		if (!jsonTranslations['']) {
			return "Die JSON-Sprachdatei enthält kein leeres Element. Sie muss aber ein leeres Element mit Definitonen für Sprache und Pluralformen enthalten!";
		}

		if (!jsonTranslations['']['language']) {
			return "Die JSON-Sprachdatei enthält kein leeres Element mit einer Sprachdefinition ('language'). Sie muss aber ein leeres Element mit Definitonen für Sprache und Pluralformen enthalten!";
		}

		if (!jsonTranslations['']['plural-forms']) {
			return "Die JSON-Sprachdatei enthält kein leeres Element mit einer Plural-Form-Definition ('plural-forms'). Sie muss aber ein leeres Element mit Definitonen für Sprache und Pluralformen enthalten!";
		}		

		return null;
	}




	private initTranslation(translationData : any)  {
		let locale = translationData['']['language'];
		console.log("GlobalValues.initTranslation: gettextJs version " + gettextJs.__version + " initialisiert, lade Sprachdatei für '" + locale + "'...");
		this.translator.loadJSON(translationData, 'messages');
		console.log("GlobalValues.initTranslation: gettextJs Sprachdatei geladen.");
		this.translator.setLocale(locale);

		let testKey = "translation successful";
		if (testKey in translationData ) {
			let testTranslation = this.translator.gettext(testKey);
			if (testKey === testTranslation) {
				throw new Error("GlobalValues.initTranslation: Die Übersetzung funktioniert nicht! Der Testschlüssel '" + testKey + "' liefert kein Ergebnis!");
			}
			console.log("GlobalValues.initTranslation: test-key '" + testKey + "' -->  '" + testTranslation + "' erfolgreicht!");
		}
		else {
			console.error("GlobalValues.initTranslation: Die Übersetzungsdatei enthält NICHT den Testschlüssel '" + testKey + "'");
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/core/GlobalValues.ts